import { useState } from "react";
import { Link } from "react-router-dom";
import { api, fmtErr } from "../api";
import AuthShell from "../components/AuthShell";
import { Field } from "../components/bits";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { const { data } = await api.post("/auth/forgot-password", { email }); setMsg(data.message); }
    catch (err) { setMsg(fmtErr(err)); } finally { setBusy(false); }
  };
  return (
    <AuthShell title="Reset your password" subtitle="We'll email you a secure link that expires in one hour." testid="forgot-page"
      footer={<Link to="/login" data-testid="back-to-login" className="font-semibold text-slate-900 hover:underline">Back to sign in</Link>}>
      <form onSubmit={submit} className="space-y-4">
        <Field label="Email"><input data-testid="forgot-email" className="input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} /></Field>
        {msg && <div data-testid="forgot-message" className="rounded-xl border border-emerald-200 bg-emerald-50 px-3 py-2 text-sm text-emerald-700">{msg}</div>}
        <button data-testid="forgot-submit" className="btn-primary w-full" disabled={busy}>{busy ? "Sending…" : "Send reset link"}</button>
      </form>
    </AuthShell>
  );
}
